import styled from "styled-components";

import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

import Button from "../Button";

import iconShare from "../../../assets/images/icons/share.svg";
import iconSave from "../../../assets/images/temp/bookmark-empty.svg";
import iconPlay from "../../../assets/images/icons/play.svg";

const InfoBoxItemProductHolder = styled.div`
  ${breakpoints.smUp} {
    width: 50%;
    flex-shrink: 0;
  }
  position: relative;
`;

const InfoBoxItemProductMediaHolder = styled.div``;

const InfoBoxItemProductHolderButtons = styled.div`
  ${breakpoints.smUp} {
    display: flex;
    align-items: center;
  }
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
`;

const InfoBoxItemProductHolderButton = styled.button`
  ${breakpoints.smUp} {
    flex: 1;
    width: 50%;
  }
  font-family: ${fonts.fontBauMedium};
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  cursor: pointer;
  text-transform: uppercase;
  ${breakpoints.smDown} {
    width: 100%;
  }
`;

const InfoBoxItemProductHolderButtonPlay = styled(InfoBoxItemProductHolderButton)`
  background-color: ${colors.tan};
  font-size: 10px;
  &:after {
    content: "";
    display: inline-block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-image: url("${iconPlay}");
    width: 9px;
    height: 9px;
  }
`;

const StyledAddSpecialPackToShoppingCartButton = styled(Button)`
  ${breakpoints.smUp} {
    flex: 1;
    width: 50%;
  }
  font-family: ${fonts.fontBauMedium};
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  cursor: pointer;
  text-transform: uppercase;
  ${breakpoints.smDown} {
    width: 100%;
  }
  background-color: ${colors.black};
  color: ${colors.white};
  font-size: 12px;
  ${(props) => props.css}
`;

const InfoBoxItemProductHolderButtonCart = styled(InfoBoxItemProductHolderButton)`
  background-color: ${colors.black};
  color: ${colors.white};
  font-size: 12px;
`;

const InfoBoxItemProductHolderButtonCartPrice = styled.span`
  font-size: 25px;
  font-family: ${fonts.fontInterstateBlackCompressed};
`;

const InfoBoxItemProductImage = styled.img`
  height: 100%;
  width: 100%;
  display: block;
  object-fit: cover;
`;

const InfoBoxItemDescriptionHolder = styled.div`
  ${breakpoints.smUp} {
    width: 50%;
    flex-shrink: 0;
    padding: 40px;
  }
  ${breakpoints.mdUp} {
    padding: 80px;
    font-size: 18px;
  }
  padding: 20px 15px;
`;

const InfoBoxItem = styled.div`
  ${breakpoints.smUp} {
    display: flex;
  }
`;

const InfoBoxItemDescriptionHolderHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${(props) => (props.noMarginBottom ? 0 : 20)}px;
`;

const InfoBoxItemDescriptionHolderHeadTitle = styled.p`
  flex: 1;
  margin-bottom: 0;
  font-size: 18px;
`;

const InfoBoxItemDescriptionHolderHeadButtons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex-shrink: 0;
  margin-left: 20px;
  line-height: 100%;
`;

const InfoBoxItemDescriptionHolderHeadButton = styled.a`
  display: inline-block;
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  &:not(:first-child) {
    margin-left: 20px;
  }
`;

const InfoBoxItemDescriptionHolderHeadButtonShare = styled(InfoBoxItemDescriptionHolderHeadButton)`
  background-image: url("${iconShare}");
`;

const InfoBoxItemDescriptionHolderHeadButtonSave = styled(InfoBoxItemDescriptionHolderHeadButton)`
  background-image: url("${iconSave}");
`;

export {
  StyledAddSpecialPackToShoppingCartButton,
  InfoBoxItem,
  InfoBoxItemProductHolder,
  InfoBoxItemProductMediaHolder,
  InfoBoxItemDescriptionHolder,
  InfoBoxItemProductImage,
  InfoBoxItemDescriptionHolderHead,
  InfoBoxItemDescriptionHolderHeadTitle,
  InfoBoxItemDescriptionHolderHeadButtons,
  InfoBoxItemDescriptionHolderHeadButtonShare,
  InfoBoxItemDescriptionHolderHeadButtonSave,
  InfoBoxItemProductHolderButtons,
  InfoBoxItemProductHolderButtonPlay,
  InfoBoxItemProductHolderButtonCart,
  InfoBoxItemProductHolderButtonCartPrice,
  InfoBoxItemDescriptionHolderHeadButton,
};
